import { render, staticRenderFns } from "./ArtistMap.vue?vue&type=template&id=983c0802&scoped=true"
import script from "./ArtistMap.vue?vue&type=script&lang=js"
export * from "./ArtistMap.vue?vue&type=script&lang=js"
import style0 from "./ArtistMap.vue?vue&type=style&index=0&id=983c0802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983c0802",
  null
  
)

export default component.exports